import React from 'react';
import { AssignmentDisplayData } from 'types/assignment';
import { PriorityEnum } from 'types/assignment';
import { DetailsSingleDatum } from './detailsSingleDatum';
import moment from 'moment';
import 'moment/locale/it';

type Props = Pick<AssignmentDisplayData, 'details' | 'pid'>;
export const AssignmentDetails: React.FC<Props> = ({
  details: { interventoID, dataCreazione, attivitaPriorita },
  pid
}) => (
  <div className="row no-gutters">
    <DetailsSingleDatum title="codice intervento" value={`${interventoID.toString()}/${pid}`} />
    <DetailsSingleDatum title="data creazione" value={moment(dataCreazione).format('L')} />
    <DetailsSingleDatum title="priorità" value={PriorityEnum[attivitaPriorita]} />
  </div>
);
